import { ArrowUpRight, FileCheck2, MessageCircle, HeartHandshake, ShieldCheck } from "lucide-react";
import { t } from "@/lib/i18n";
import { useReveal } from "@/hooks/useReveal";

export const ACTA_CLARA_URL = process.env.REACT_APP_ACTA_CLARA_URL;

const FEATURES = [
  [FileCheck2, "senior.f1"],
  [MessageCircle, "senior.f2"],
  [ShieldCheck, "senior.f3"],
];

export const SeniorSection = () => {
  const [ref, inView] = useReveal();
  return (
    <section id="adultos-mayores" ref={ref} data-testid="senior-section" className="relative scroll-mt-16 border-y border-ac-line bg-ac-surface">
      <div className={`ac-reveal ${inView ? "is-in" : ""} mx-auto grid max-w-[1300px] items-center gap-12 px-4 py-24 sm:px-8 lg:grid-cols-[1.2fr_1fr] lg:py-28`}>
        <div>
          <p className="ac-eyebrow flex items-center gap-2"><HeartHandshake className="h-4 w-4" /> {t("senior.kicker")}</p>
          <h2 className="mt-5 font-wide text-4xl font-normal leading-[1.05] text-ac-ink sm:text-5xl">{t("senior.title")}</h2>
          <p className="mt-6 max-w-xl text-xl leading-relaxed text-ac-text">{t("senior.desc")}</p>
          <ul className="mt-8 space-y-4">
            {FEATURES.map(([I, k]) => (
              <li key={k} className="flex items-start gap-4 text-lg text-ac-text">
                <span className="ac-grad grid h-10 w-10 shrink-0 place-items-center rounded-full text-white"><I className="h-5 w-5" /></span>
                <span className="pt-1.5">{t(k)}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="rounded-3xl border-2 border-ac-primary-line bg-ac-bg p-8 sm:p-10">
          <p className="font-mark text-3xl font-bold text-ac-ink">Acta Clara</p>
          <p className="mt-3 text-lg leading-relaxed text-ac-muted">{t("senior.card")}</p>
          <a
            data-testid="senior-open-acta-clara"
            href={ACTA_CLARA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 flex min-h-[64px] w-full items-center justify-center gap-3 rounded-2xl bg-ac-primary px-6 text-lg font-bold text-white shadow-[0_14px_34px_-14px_var(--ac-primary-glow)] transition-[transform,background-color] hover:-translate-y-0.5 hover:bg-ac-primary-hover focus:outline-none focus-visible:ring-4 focus-visible:ring-ac-primary-ring"
          >
            {t("senior.cta")} <ArrowUpRight className="h-6 w-6" />
          </a>
          <p className="mt-4 text-center text-sm text-ac-muted">{t("senior.note")}</p>
        </div>
      </div>
    </section>
  );
};
